import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
const uuid = require('uuid');

const Globals = require('../../../../../app/globals');
const Strings = require('../../../../../app/shared/Strings');
const OrganizationActions = require('../../../actions/OrganizationActions');
import WithOrganizationActivityMetaTags from '../../DataHOCs/WithOrganizationActivityMetaTags';
import WithOrganizationActivityMetaTagImportChanges from '../../DataHOCs/WithOrganizationActivityMetaTagImportChanges';
import AccessibleIcon from '../../common/AccessibleIcon';
import ErrorBox from '../../common/ErrorBox';

const propTypes = {
    className: PropTypes.string,
    orgId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    category: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        display_name: PropTypes.string.isRequired,
        type: PropTypes.oneOf(Object.values(Globals.activity_meta_tag.category_type)).isRequired,
        allow_multiple: PropTypes.bool.isRequired,
        requires_order: PropTypes.bool.isRequired,
    }).isRequired,
    orgActMetaTags: PropTypes.object.isRequired,
    organizationStoreAction: PropTypes.object.isRequired,
    orgActMetaImportChanges: PropTypes.shape({
        tagsToAdd: PropTypes.array,
        tagsToDelete: PropTypes.array,
        tagsToUpdate: PropTypes.array,
        existingTagsHash: PropTypes.string.isRequired,
    }).isRequired,
};

const defaultProps = {
    className: '',
};

class OrgActMetaTagImportChanges extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            confirmActionId: null,
            error: null,
        };

        this.onCancelChanges = this.onCancelChanges.bind(this);
        this.onConfirmChanges = this.onConfirmChanges.bind(this);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.organizationStoreAction.id === this.state.confirmActionId) {
            this.setState({
                confirmActionId: null,
                error: nextProps.organizationStoreAction.error || null,
            });
        }
    }

    onCancelChanges() {
        if (!!this.state.confirmActionId) return;

        this.setState({ error: null }, () => {
            OrganizationActions.clearImportActMetaTagChanges(uuid.v4(), { orgId: this.props.orgId, categoryId: this.props.category.id });
        })
    }

    onConfirmChanges() {
        const confirmActionId = uuid.v4();
        this.setState({ confirmActionId: confirmActionId }, () => {
            OrganizationActions.confirmImportActMetaTagChanges(
                confirmActionId,
                { 
                    orgId: this.props.orgId,
                    categoryId: this.props.category.id,
                    operations: this.props.orgActMetaImportChanges,
                }
            );
        });
    }

    render() {
        let noChanges = (
            !this.props.orgActMetaImportChanges 
            || (
                !this.props.orgActMetaImportChanges.tagsToAdd.length
                // && !this.props.orgActMetaImportChanges.tagsToDelete.length
                && !this.props.orgActMetaImportChanges.tagsToUpdate.length
            )
        );
        let updateExistingError = false; // unable to find existing tag in store that will updated during operation

        return (
            <div className={this.props.className}>
                {noChanges ?
                    <div className="font-style-italic font-weight-bold text-centered margin-bottom-lg">
                        No changes detected in imported file
                    </div>
                    :
                    <div>
                        <ErrorBox error={this.state.error} />
                        <div className="margin-bottom-xl">
                            <div className="sm-heading margin-bottom-lg">Added Tags</div>
                            <div className="sub-heading">The following tags are new and will be added:</div>
                            {this.props.orgActMetaImportChanges.tagsToAdd.map((tagToAdd) =>
                                <div className="tagBlock margin-bottom-md" key={`add-${tagToAdd.tag}`}>
                                    <div className="tagBlock__icon success-text">
                                        <AccessibleIcon className="fa fa-plus" label="Adding" />
                                    </div>
                                    <div className="tagBlock_info">
                                        <div className="tagBlock__attr">{Strings['en'].act_meta_tags.TAG_NAME}: <span className="font-weight-bold">{tagToAdd.tag}</span></div>
                                        {(this.props.category.requires_order) &&
                                            <div className="tagBlock__attr">{Strings['en'].act_meta_tags.DISPLAY_ORDER}: <span className='font-style-italic'>{tagToAdd.display_order}</span></div>
                                        }
                                    </div>
                                </div>
                            )}
                            {!this.props.orgActMetaImportChanges.tagsToAdd.length &&
                                <div className="font-style-italic font-weight-bold font-size-14px">
                                    None (No changes detected in imported file)
                                </div>
                            }
                        </div>
                        {/*
                        <div className="margin-bottom-xl">
                            <div className="sm-heading margin-bottom-lg">Deleted Tags</div>
                            <div className="sub-heading">The following tags are not present in the imported file and will be deleted:</div>
                            {this.props.orgActMetaImportChanges.tagsToDelete.map((tagToDelete) =>
                                <div className="tagBlock margin-bottom-md" key={`delete-${tagToDelete.id}`}>
                                    <div className="tagBlock__icon danger-text">
                                         <AccessibleIcon className="fa fa-trash" label="Deleting" />
                                    </div>
                                    <div className="tagBlock__info">
                                        <div className="tagBlock__attr">Name: <span className="font-weight-bold">{tagToDelete.tag}</span></div>
                                        <div className="tagBlock__attr">Description: <span className='font-style-italic'>{tagToDelete.description}</span></div>
                                    </div>
                                </div>
                            )}
                            {!this.props.orgActMetaImportChanges.tagsToDelete.length &&
                                <div className="font-style-italic font-weight-bold font-size-14px">
                                    None (No changes detected in imported file)
                                </div>
                            }
                        </div>
                        */}
                        {(this.props.category.requires_order) && // only valid case for a tag being updated (otherwise, hide this information)
                            <div className="margin-bottom-xl">
                                <div className="sm-heading margin-bottom-lg">Updated Tags</div>
                                <div className="sub-heading">The following tags have changes in the imported file and will be updated accordingly:</div>
                                {this.props.orgActMetaImportChanges.tagsToUpdate.map((tagToUpdate) => {
                                    const existingTag = this.props.orgActMetaTags[this.props.category.id][tagToUpdate.id];
                                    if (!existingTag) {
                                        updateExistingError = true;
                                        return (
                                            <div key={`update-${tagToUpdate.id}`}>
                                                Error matching tag update to an existing tag.
                                            </div>
                                        );
                                    }

                                    return (
                                        <div className="tagBlock margin-bottom-md" key={`update-${tagToUpdate.id}`}>
                                            <div className="tagBlock__icon">
                                                <AccessibleIcon className="fa fa-refresh" label="Updating" />
                                            </div>
                                            <div className="tagBlock__info">
                                                <div className="tagBlock__attr">{Strings['en'].act_meta_tags.TAG_NAME}: <span className="font-weight-bold">{tagToUpdate.tag}</span></div>
                                                <div className="tagBlock__attr">New {Strings['en'].act_meta_tags.DISPLAY_ORDER}: <span className='font-style-italic'>{tagToUpdate.display_order}</span></div>
                                                <div className="tagBlock__attr">Old {Strings['en'].act_meta_tags.DISPLAY_ORDER}: <span className='font-style-italic'>{existingTag.display_order}</span></div>
                                            </div>
                                        </div>
                                    );
                                })}
                                {!this.props.orgActMetaImportChanges.tagsToUpdate.length &&
                                    <div className="font-style-italic font-weight-bold font-size-14px">
                                        None (No changes detected in imported file)
                                    </div>
                                }
                            </div>
                        }
                    </div>
                }
                <div className="fr">
                    <Button 
                        className="margin-right-md"
                        disabled={!!this.state.confirmActionId}
                        onClick={this.onCancelChanges}
                    >
                            Cancel
                    </Button>
                    <Button
                        variant='danger'
                        disabled={noChanges || updateExistingError || !!this.state.confirmActionId}
                        onClick={this.onConfirmChanges}
                    >
                        Confirm Changes
                    </Button>
                </div>
                <div className="float-clear" />
            </div>
        );
    }
}

OrgActMetaTagImportChanges.propTypes = propTypes;
OrgActMetaTagImportChanges.defaultProps = defaultProps;

export default WithOrganizationActivityMetaTags(WithOrganizationActivityMetaTagImportChanges(OrgActMetaTagImportChanges));